<script setup>
import { useParentElement } from '@vueuse/core'
import { onMounted, onUnmounted } from 'vue'

const parent = useParentElement()

onMounted(() => {
  if (parent.value.nodeName == 'BODY') {
    parent.value.classList.toggle('modal-open')
  }
})
onUnmounted(() => {
  if (parent.value.nodeName == 'BODY') {
    parent.value.classList.toggle('modal-open')
  }
})
</script>
<template>
  <div class="modal-backdrop fade show blockscreen">
    <span class="spinner-border spinner-border-xl" />
  </div>
</template>
